import React from "react";
import MainLayout from "./MainLayout";
import MyTeam from "../common/MainContent/Home/MyTeam";

const MyTeamPage = (props) => <MainLayout component={MyTeam} />;

export default MyTeamPage;
